module.exports = __webpack_public_path__ + "static/media/separator.b8d1d844.svg";